import {
  SidePanelDS,
  Spacer,
  TextCapitalized,
  dateFormatterDayMonthYearLong2Digits,
} from "@qivia/ui";
import { colors } from "@qivia/ui/src/styles/figmaColors";
import { typographies } from "@qivia/ui/src/styles/figmaTypographies";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { HomeChargingSupportingDocument } from "../../homeChargingSupportingDocumentsAPI";
import "../../../../../i18n/i18n";

export const SupportingDocumentDetails = (props: {
  supportingDocument: HomeChargingSupportingDocument;
}) => {
  const { t } = useTranslation();
  const { supportingDocument } = props;

  const createdAtValue = useMemo(() => {
    if (!supportingDocument.supportingDocument) {
      return null;
    }
    return t(
      "home_charging_supporting_documents.sidePanel.detail.createdAtValue",
      {
        date: dateFormatterDayMonthYearLong2Digits(
          new Date(supportingDocument.supportingDocument.createdAt),
        ),
        author: `${supportingDocument.supportingDocument.createdBy.firstName} ${supportingDocument.supportingDocument.createdBy.lastName.charAt(0)}.`,
      },
    );
  }, [supportingDocument.supportingDocument, t]);

  return (
    <>
      <SectionTitle>
        <TextCapitalized>
          {t("home_charging_supporting_documents.sidePanel.detail.title")}
        </TextCapitalized>
      </SectionTitle>
      <Spacer y={2} />
      <SidePanelDS.SectionRow
        label={
          <SectionRowLabel>
            <TextCapitalized>
              {t(
                "home_charging_supporting_documents.sidePanel.detail.chargesCount",
              )}
            </TextCapitalized>
          </SectionRowLabel>
        }
        value={supportingDocument.chargesCount}
      />
      <Spacer y={2} />
      <SidePanelDS.SectionRow
        label={
          <SectionRowLabel>
            <TextCapitalized>
              {t(
                "home_charging_supporting_documents.sidePanel.detail.totalEnergy",
              )}
            </TextCapitalized>
          </SectionRowLabel>
        }
        value={`${supportingDocument.totalEnergy} kWh`}
      />
      {createdAtValue && (
        <>
          <Spacer y={2} />
          <SidePanelDS.SectionRow
            label={
              <SectionRowLabel>
                <TextCapitalized>
                  {t(
                    "home_charging_supporting_documents.sidePanel.detail.createdAt",
                  )}
                </TextCapitalized>
              </SectionRowLabel>
            }
            value={createdAtValue}
          />
        </>
      )}
    </>
  );
};

const SectionTitle = styled.div`
  ${typographies["Body/L"]}
  color: ${colors["colors/text/darkGrey"]}
`;

const SectionRowLabel = styled.div`
  ${typographies["Body/L"]}
  color: ${colors["colors/text/black"]}
`;
